import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { CSVLink } from 'react-csv';
import Grid from '@material-ui/core/Grid';
import VoucherTableHead from './VoucherTableHead';
import VoucherRow from './VoucherRow';
import KobooTablePagination from '../Layout/KobooTablePagination.jsx';
import { ROLE_USER } from '../../constants/roles';
import StringService from '../../services/StringService';
import { changeVoucherTabAction } from '../../store/ui/actions';
import KobooButton from '../Layout/KobooButton';
import { IconButton, InputBase } from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import Loader from '../Layout/Loader';

const styles = () => (
  {
    table: {
      minWidth: 700,
    },
    fabProgress: {
      color: 'primary',
      position: 'absolute',
      top: -6,
      left: -6,
      zIndex: 1,
    },
    paperTab: { width: '75%' },
    formRoot: {
      padding: '2px 4px',
      display: 'flex',
      alignItems: 'center',
      width: 400,
    },
    input: {
      flex: 1,
    },
    iconButton: {
      padding: 10,
    },
  }
);

const types = ['Usage unique', 'Abonnement', 'Usage Multiple'];

export class VoucherTable extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
    changeVoucherTabAction: PropTypes.func.isRequired,
    voucher_tab: PropTypes.any.isRequired,
    pending: PropTypes.bool.isRequired,
    vouchers: PropTypes.array
  };

  constructor(props, context) {
    super(props, context);

    this.state = {
      order: 'desc',
      orderBy: 'number',
      data: [],
      page: 0,
      rowsPerPage: 500,
      vouchersCount: 0,
      role: ROLE_USER,
      selectedTab: null,
      previousSelectedTab: null,
      siteFilter: '',
      previousSiteFilter: '',
    };
  }

  static voucherIsFinished = voucher => {
    return (
      (
        voucher.type === 0 && voucher.rents && voucher.rents.length > 0
      )
      || (
        voucher.end_date && voucher.end_date < (
          Date.now() / 1000 | 0
        )
      )
    );
  };

  static voucherInUse = voucher => {
    return (
      (
        voucher.type !== 0 && voucher.rents && voucher.rents.length > 0
        && voucher.end_date && voucher.end_date > (
          Date.now() / 1000 | 0
        )
      )
    );
  };

  static getNewTableData = (state, props) => {
    let selectedData = [];
    let vouchers = props.vouchers ? props.vouchers : [];
    const actualTab = state.selectedTab !== null
      ? state.selectedTab
      : props.voucher_tab;
    switch (actualTab) {
      case 0:
        selectedData = vouchers.filter(voucher => !VoucherTable.voucherIsFinished(voucher)
          && !VoucherTable.voucherInUse(voucher));
        break;
      case 1:
        selectedData = vouchers.filter(voucher => voucher.type === 0
          && !VoucherTable.voucherIsFinished(voucher) && !VoucherTable.voucherInUse(voucher));
        break;
      case 2:
        selectedData = vouchers.filter(voucher => voucher.type === 1
          && !VoucherTable.voucherIsFinished(voucher) && !VoucherTable.voucherInUse(voucher));
        break;
      case 3:
        selectedData = vouchers.filter(voucher => voucher.type === 2
          && !VoucherTable.voucherIsFinished(voucher) && !VoucherTable.voucherInUse(voucher));
        break;
      case 4:
        selectedData = vouchers.filter(voucher => VoucherTable.voucherInUse(voucher));
        break;
      case 5:
        selectedData = vouchers.filter(voucher => VoucherTable.voucherIsFinished(voucher));
        break;
    }
    if (state.siteFilter !== null && state.siteFilter !== '') {
      selectedData = selectedData.filter(voucher =>
        voucher.siteName
        && voucher.siteName.toUpperCase().indexOf(state.siteFilter.toUpperCase()) !== -1
      );
    }
    return {
      page: 0,
      previousSelectedTab: actualTab,
      previousSiteFilter: state.siteFilter,
      data: selectedData.sort((a, b) => VoucherTable.sort(a, b, state.orderBy, state.order)),
    };
  }

  static getDerivedStateFromProps(props, state) {
    let newState = null;
    if (props.authUser && props.roles) {
      newState = {
        ...newState,
        role: props.roles[props.authUser.uid],
      };
    }
    if (state.selectedTab === null) {
      newState = {
        ...newState,
        selectedTab: props.voucher_tab,
      };
    }
    if (props.vouchers  !== undefined && props.vouchers  !== null) {
      if (
        state.selectedTab === null
        || state.selectedTab !== state.previousSelectedTab
        || state.siteFilter !== state.previousSiteFilter
        || state.vouchersCount !== props.vouchers.length
      ) {
        newState = {
          ...newState,
          ...VoucherTable.getNewTableData(state, props),
          vouchersCount: props.vouchers ? props.vouchers.length : 0
        };
      }
    }

    return newState;
  }

  vouchersForCSV = () => {
    let datas = [];

    for (let voucher of this.state.data) {
      let data = Object();
      data['Code'] = voucher.code;
      data['Loueur'] = voucher.renterName;
      data['Sites'] = voucher.siteName;
      data['Type'] = types[voucher.type];
      data['Valeur'] = voucher.value / 100;
      data['Reduction'] = voucher.percent;
      data['Date de fin de validite'] = voucher.end_date
        ?
        StringService.dateTimestampToString(voucher.end_date)
        : '';

      datas.push(data);
    }
    return datas;
  };

  static sort(a, b, property, order) {
    let prop1,
      prop2;
    if (property === 'siteName') {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property].toUpperCase()
        : '';
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property].toUpperCase()
        : '';
    } else {
      prop1 = (
        a[property] !== null && a[property] !== undefined
      )
        ? a[property]
        : -1;
      prop2 = (
        b[property] !== null && b[property] !== undefined
      )
        ? b[property]
        : -1;
    }
    if (order === 'asc') {
      return prop1 > prop2
        ? -1
        : 1;
    }
    return prop1 < prop2
      ? -1
      : 1;
  }

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy && this.state.order === order) {
      order = 'asc';
    }
    const data = this.state.data.sort((a, b) => VoucherTable.sort(a, b, orderBy, order));
    this.setState({
      data,
      order,
      orderBy,
    });
  };

  handleChangeTab = (event, value) => {
    this.props.changeVoucherTabAction(value);
    this.setState({ selectedTab: value });
  };

  handleChangePage = (event, page) => {
    this.setState({ page });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: event.target.value });
  };

  clickDownloadCsv = (event) => {
    event.stopPropagation();
    document.getElementById('csv_link_voucher').click();
  };

  onSubmitFilter = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ siteFilter: event.target.search.value });
  };

  render() {
    const {
      classes,
      vouchers,
      pending
    } = this.props;

    const {
      rowsPerPage,
      page,
      data,
      order,
      orderBy,
      siteFilter,
    } = this.state;

      return (
        <React.Fragment>
          <Grid
            container
            direction="row"
            justifyContent="space-between"
            alignItems="center"
          >
            <Grid item>
              <Paper component="form" className={classes.formRoot} onSubmit={this.onSubmitFilter}>
                <InputBase
                  id="site"
                  name="search"
                  className={classes.input}
                  placeholder="Filter les sites"
                  inputProps={{ 'aria-label': 'Filter les sites' }}
                  defaultValue={siteFilter}
                />
                <IconButton type="submit" className={classes.iconButton} aria-label="search">
                  <SearchIcon />
                </IconButton>
              </Paper>
            </Grid>
            <Grid item>
              <KobooButton type="button" onClick={this.clickDownloadCsv}>
                Télécharger le CSV
              </KobooButton>
            </Grid>
          </Grid>
          <CSVLink
            id="csv_link_voucher"
            filename={`coupons-${new Date().getTime()}.csv`}
            data={this.vouchersForCSV()}
            style={{ display: 'none' }}
          >-</CSVLink>
          <div>
            <Paper className={classes.paperTab}>
              <Tabs
                value={this.state.selectedTab}
                onChange={this.handleChangeTab}
                indicatorColor="primary"
                textColor="primary"
              >
                <Tab label="TOUS" />
                <Tab label="USAGE UNIQUE" />
                <Tab label="ABONNEMENT" />
                <Tab label="USAGE MULTIPLE" />
                <Tab label="EN COURS" />
                <Tab label="TERMINÉS" />
              </Tabs>
            </Paper>
            <Table className={classes.table}>
              <VoucherTableHead
                onRequestSort={this.handleRequestSort}
                order={order}
                orderBy={orderBy}
                rowCount={data.length}
              />
              <TableBody>
                {pending
                && <tr>
                  <td colSpan={8}>
                    <Loader/>
                  </td>
                </tr>}
                {!pending && vouchers !== null && vouchers.length > 0
                && data.slice(
                  page * rowsPerPage,
                  (
                    page * rowsPerPage
                  ) + rowsPerPage,
                ).map(voucher => (
                  <VoucherRow key={voucher.id} voucher={voucher} />
                ))}
                {!pending && vouchers !== null && vouchers.length <= 0
                && <tr>
                    <td colSpan={8}>
                      <Typography variant="subtitle1">Aucun coupon</Typography>
                    </td>
                </tr>
                }
              </TableBody>
            </Table>

          </div>
          <KobooTablePagination
            numberOfItems={data.length}
            rowsPerPage={rowsPerPage}
            label="Coupons par page"
            page={page}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </React.Fragment>
      );
  }
}

function mapStateToProps(state) {
  return {
    authUser: state.users.authUser,
    roles: state.roles.content,
    voucher_tab: state.ui.voucher_tab,
  };
}

export default compose(
  connect(mapStateToProps, { changeVoucherTabAction }),
  withStyles(styles),
)(VoucherTable);



// WEBPACK FOOTER //
// ./src/components/Voucher/VoucherTable.jsx